import { PRODUCT_CARD_CONTAINER_ID } from '../../../app/constants';
import { PRODUCT_CARD_ITEM_CLASSNAME } from '@vfde-brix/ws10/product-card';

/**
 * Scroll to the first loaded device
 */
export const focusOnAddedDevices = (oldDevicesLength: number): void => {
    if (oldDevicesLength <= 0) {
        return;
    }

    const deviceList = document.getElementById(PRODUCT_CARD_CONTAINER_ID) as HTMLElement;
    const devices = deviceList.getElementsByClassName(PRODUCT_CARD_ITEM_CLASSNAME);
    const newDeviceToFocus = devices.item(oldDevicesLength) as HTMLElement;

    if (newDeviceToFocus) {
        // need to wait a few ms to avoid spontaneously jumping after the browser re-rendered
        setTimeout(() => {
            newDeviceToFocus.scrollIntoView({ block: 'center', behavior: 'smooth' });
            newDeviceToFocus.focus({ preventScroll: true });
        }, 50);
    }
};
